import { useEffect } from "react";
import L from "leaflet";
import "./TopLegend.css";
import Logo from '../fonts/logo.png'
function Legend({ map,position }) {
  useEffect(() => {
    if (map) {
      const legend = L.control({ position: position });

      legend.onAdd = () => {
        const div = L.DomUtil.create("div", "top_cutsom_legend");

        div.innerHTML = "<img src="+ Logo +" height='80' width='150'>"
        div.innerHTML +=
          "<p class='top_legend-title'>KASHTA &ensp;	IN &ensp;	ABU DHABI</p>" +
          "";
        return div;
      };

      legend.addTo(map);
    }
  }, [map,position]);
  return null;
}

export default Legend;
